import { analytics } from 'moet-core';

export const ANALYTICS_EVENTS = {
  recaptchaShowing: new analytics.Event({
    name: 'Recaptcha Challenge Showing',
    description: 'User is asked to solve the Recaptcha challenge',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.RECAPTCHA,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: [],
  }),
  recaptchaSubmitted: new analytics.Event({
    name: 'Recaptcha Challenge Submitted',
    description: 'User solved the Recaptcha Challenge',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.RECAPTCHA,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: [],
  }),
  recaptchaExpired: new analytics.Event({
    name: 'Recaptcha Response Expired',
    description: 'The Recaptcha response has expired',
    action: analytics.EVENT_ACTION.FORM_SUBMIT,
    category: analytics.EVENT_CATEGORY.RECAPTCHA,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: [],
  }),
};
